import React, { useState, useEffect } from "react";
import ApiCustom from "../../utils/ApiCustom";
import {
  ArrowDownTrayIcon,
  CheckIcon,
} from "@heroicons/react/24/solid";

const PolicyModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (isOpen) {
      getData();
    }
  }, [isOpen]);

  const getData = async () => {
    ApiCustom.get("/posts-public/71")
      .then((res) => {
        setFormData(res.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const handleDownloadWord = () => {
    const documentTitle = formData?.title || "Điều khoản";
    const safeFileName = documentTitle
      .replace(/[\\/:*?"<>|]/g, "-")
      .replace(/\s+/g, " ")
      .trim();
    const documentContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>${documentTitle}</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 14pt; line-height: 1.6; }
            h1 { font-size: 24pt; margin-bottom: 24px; }
            img { max-width: 100%; height: auto; }
          </style>
        </head>
        <body>
          <h1>${documentTitle}</h1>
          ${formData?.content || ""}
        </body>
      </html>
    `;
    const blob = new Blob(["\ufeff", documentContent], {
      type: "application/msword;charset=utf-8",
    });
    const downloadUrl = URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");

    downloadLink.href = downloadUrl;
    downloadLink.download = `${safeFileName || "dieu-khoan"}.doc`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
    URL.revokeObjectURL(downloadUrl);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-base-100 pb-0 rounded-lg w-3/4 max-h-[90vh] overflow-y-auto">
        <form>
          <div className="w-full">
            <div className="flex sticky top-0 bg-base-100 z-10 justify-end px-6 py-4 items-center ">
              <button
                type="button"
                onClick={() => onClose(false)}
                className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
              >
                X
              </button>
            </div>

            <div className="flex flex-col gap-3 px-6 sm:flex-row sm:items-center sm:justify-between">
              <h1 className="text-3xl font-bold mb-4">{formData?.title}</h1>
              <button
                type="button"
                onClick={handleDownloadWord}
                className="btn btn-sm border-0 bg-sky-600 text-white hover:bg-sky-700"
              >
                <ArrowDownTrayIcon className="h-5 w-5" />
                Tải bản Word
              </button>
            </div>

            <div className="flow-root">
              <div className="sun-editor-editable">
                <div
                  className="prose max-w-none px-6"
                  dangerouslySetInnerHTML={{ __html: formData?.content }}
                />
              </div>
            </div>

            <div className="flex sticky bottom-0 bg-base-100 z-10 p-6 pt-4 justify-end space-x-4 mt-3">
              <button
                type="button"
                onClick={() => onClose(true)}
                className="px-4 py-2 btn border-0 bg-green-600 hover:bg-green-800 rounded btn-sm text-white"
              >
                <CheckIcon className="w-5 h-5" />
                Đồng ý
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PolicyModal;
